import { render, staticRenderFns } from "./Acordion.vue?vue&type=template&id=da897490&scoped=true&"
var script = {}
import style0 from "./Acordion.vue?vue&type=style&index=0&id=da897490&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da897490",
  null
  
)

export default component.exports